import HeaderSection from "@/components/Header/HeaderSection.vue";
import SettingsUserManagementTab from "@/components/SettingsUserManagementTab/SettingsUserManagementTab.vue";
import { get_user_profile, fetch_and_store_user_profile } from "@/router";

export default {
    name: "UserManagementView",

    components: {
        HeaderSection,
        SettingsUserManagementTab
    },

    data() {
        return ({
            breadcrumb: [
                { id: "home", title: "Dashboard" },
                { id: "user-management", title: "User Management" }
            ],
            user_profile: null
        });
    },

    async mounted() {
        this.user_profile = get_user_profile() || await fetch_and_store_user_profile();
    },

    methods: {
        handleBreadcrumbClick(id) {
            if (id === "home") {
                this.$router.push("/home");
            }
        }
    }
};
